module.exports = __webpack_public_path__ + "img/tomato-01.9452efd4.svg";